import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import api from "../../lib/api";
import { Card } from "../../components/ui/Card";
import { formatDay } from "../../lib/utils";

export default function Reviews() {
  const [reviews, setReviews] = useState(null);

  useEffect(() => {
    api
      .get("/reviews")
      .then(({ data }) => setReviews(data.data || []))
      .catch(() => setReviews([]));
  }, []);

  return (
    <div>
      <h1 className="mb-4 font-montserrat text-2xl font-bold text-slate-900">Your reviews</h1>
      {reviews === null ? (
        <p className="text-muted-foreground">Loading…</p>
      ) : reviews.length === 0 ? (
        <p className="text-muted-foreground">
          You haven't reviewed a visit yet. After a completed appointment, use "Leave a review" on your{" "}
          <Link to="/account/appointments" className="font-medium text-primary underline">
            appointments page
          </Link>
          .
        </p>
      ) : (
        <div className="space-y-3">
          {reviews.map((r) => (
            <Card key={r.id} className="p-4">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <Link to={`/${r.business?.slug}`} className="font-semibold text-slate-900 hover:underline">
                  {r.business?.name}
                </Link>
                <span className="text-xs text-muted-foreground">{formatDay(r.created_at)}</span>
              </div>
              <div className="mt-1 flex gap-0.5" aria-label={`${r.rating} out of 5`}>
                {[1, 2, 3, 4, 5].map((n) => (
                  <Star key={n} className={`h-4 w-4 ${n <= r.rating ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
                ))}
              </div>
              {r.comment && <p className="mt-2 text-sm text-slate-700">{r.comment}</p>}
              {r.business_reply && (
                <p className="mt-2 rounded-lg bg-muted p-2 text-sm text-slate-700">
                  <span className="font-semibold">{r.business?.name} replied:</span> {r.business_reply}
                </p>
              )}
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}